<template>
	<div>
		<div class="actDiv">
			<label style="color: red; font-size: 0.8rem;margin-right: 0.1rem;">*</label>
			<label style="font-size: 0.8rem;margin-left: 0.5rem;">选择月份：</label>
			 <a-month-picker v-model="theMonth" placeholder="请选择月份" style="width: 10rem;"/>
			 <label style="font-size: 0.8rem;margin-left: 0.5rem;">选择小区：</label>
			 <a-select  style="width:12rem; font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
			 			    option-filter-prop="children"  :filter-option="filterOption" show-search allowClear>
			 	<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			 </a-select>
			 <a-button style="margin:0 0.5rem;"  @click="doQuery" :disabled="theMonth == null" size="small"   icon="search">查询</a-button>
			 <a-button style="margin:0 0.5rem;"  @click="doExport" :disabled="list.length == 0" size="small"   icon="download">导出</a-button>
		</div>
		<vxe-table  align="center" :data="list"  border max-height="600"  ref="mTable"
						  resizable highlight-hover-row :loading="loading" size="mini">
			<vxe-table-column type="seq" width="50"></vxe-table-column>
			<vxe-table-column title="小区" field="NeighborName" ></vxe-table-column>
			<vxe-table-column title="用户号" field="customer_num" ></vxe-table-column>
			<vxe-table-column title="换表前地址" field="old_meter_addr"  ></vxe-table-column>
			<vxe-table-column title="换表后地址" field="change_meter_addr" ></vxe-table-column>
			<vxe-table-column title="换表前读数" field="old_meter_end_read"  ></vxe-table-column>
			<vxe-table-column title="换表后读数" field="change_meter_end_read"  ></vxe-table-column>
			<vxe-table-column title="换表前钢印号" field="old_meter_steel_num"  ></vxe-table-column>
			<vxe-table-column title="换表后钢印号" field="change_meter_steel_num"  ></vxe-table-column>
			<vxe-table-column title="操作人" field="create_user_name" ></vxe-table-column>
			<vxe-table-column title="操作时间" field="create_time" :formatter="getTimeFormatter"></vxe-table-column>
		</vxe-table>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				theMonth:'2024-05',
				neighborList:[],
				theNeighbor:'',
				loading:false,
				list:[],
			} 
		},
		methods: {
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
		 	queryNeighbors:function(){
		 		let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
		 		this.Api.fetchPostWithForm(url).then((data)=>{
		 			let code = data.data.code;
		 			let result = data.data.result;
		 			let msg = data.data.message;
		 			if(code == this.Api.HTTP_OK_CODE){
		 				this.neighborList = result;
		 			}else{
		 				this.$message.error(msg);
		 			}
		 		}).catch((error)=>{
		 			console.log(error);
		 		});
		 	},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			doQuery(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_METER_CHANGE_URL);
				let param = {
					theNeighbor:this.theNeighbor.key,
					theMonth:this.$moment(this.theMonth).format('YYYY-MM')
				};
				console.log(param);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				});
			},
			doExport(){
				this.$refs.mTable.exportData({ type: 'csv' })
			},
		},
		created(){
			this.queryNeighbors();
		},
		computed: {
			theMonth() {
				return moment().format('YYYY-MM');
			}
		},
	}
</script>

<style>
</style>
